export default __webpack_public_path__ + "static/speedup-construction-c335369cdfe406c62c2aafb5ba81ec96.svg";